
import { mapActions } from 'vuex'

export default {
  props: {
    shoppingList: {
      type: Object,
      required: true,
    },

    hideTextOnMobile: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    addableProducts() {
      // get all IDs of products in the shopping list
      return (
        this.shoppingList?.products?.filter((p) => {
          return p.buyable_in_shop && !this.canOnlyBeBoughtExternally(p)
        }) ?? []
      )
    },
  },

  methods: {
    ...mapActions('cart', ['increaseAmount']),

    async addShoppingListToCart() {
      const productIds = this.addableProducts.map((p) => p.id)

      // abort when there are no products to add
      if (productIds.length === 0) {
        return
      }

      try {
        await this.increaseAmount({
          itemIds: productIds,
          amount: 1,
          shoppingListCode: this.shoppingList.code,
        })

        this.$toast.success(this.$t('shopping-list-added-to-cart'))
      } catch (error) {
        this.$toast.error(this.$t('shopping-list-error-adding-to-cart'))

        this.$sentry.captureException(error)
      }
    },

    canOnlyBeBoughtExternally(product) {
      return ['E-Book', 'App'].includes(product.product_type)
    },
  },
}
